import permissions from 'constants/permissions'

const ORGANIZATION_COMPANY_LIST = [
  {
    name: 'Visualizar',
    tag: permissions.ORGANIZATION_COMPANY.VIEW,
  },
  {
    name: 'Gerenciar',
    tag: permissions.ORGANIZATION_COMPANY.MANAGE,
  },
]

export default ORGANIZATION_COMPANY_LIST
